import _ from 'lodash'
import React, { useState } from 'react'
import { CaretRightIcon } from 'images/icons/general/'
import { CaretDownIcon } from "images/icons/tools/"

import Isvg from 'react-inlinesvg'

import { diffif as DefaultChange } from './default-change'
import { diffif as UserChange } from './user-change'
import { diffif as UserGroupChange } from './user-group-change'
import { diffif as PortfolioChange } from './portfolio-change'
import { diffif as PortfolioAssetChange } from './portfolio-asset-change'
import { diffif as AssetAttributeChange } from './asset-attribute-change'
import { diffif as ChartChange } from './chart-change'
import { diffif as PermissionChange } from './permission-change'
import { diffif as EventChange } from './event-change'
import { diffif as CalcChange } from './calc-change'
import { diffif as CopyChange } from './copy-change'
import { diffif as CopyEventChange } from './copy-event-change'
import { diffif as FolderChange } from './folder-edit-change'
import { render, Diff} from '../lib/render-object'

export type ChangeProps = {
  resource: string
  change: string //json
  user: {
    id: string
    email: string
    name: string
    service?: string
  }
  created: Date
  method: 'POST' | 'PATCH' | 'DELETE' | 'MARK'
}
type Parsed = ChangeProps & { diffs: Diff[], atRest: string }
type DiffIf = (ChangeProps) => null | (() => Parsed)
const renderers: DiffIf[] = [UserChange, UserGroupChange, PortfolioChange, PortfolioAssetChange, AssetAttributeChange, ChartChange, PermissionChange, FolderChange, CalcChange, CopyChange, /*CopyEventChange,*/ EventChange]

export const getParser = (props: ChangeProps) => {
  for (let isa of renderers) {
    const parser = isa(props)
    if (parser) return parser
  }
  return DefaultChange(props)
}
export const ChangeRenderer = (props: ChangeProps) => {
  const parser = getParser(props)
  return <Change {...parser()}/>
}

export const Change = (props) => {
  const [show, setShow] = useState(false)
  const toggleShow = () => setShow(!show)

  let rendered
  if (show && (props.method !== 'POST' || props._showCreate)) rendered = render(props.diffs)
  return (
    <div onClick={toggleShow}>
      <Isvg src={show ? CaretDownIcon : CaretRightIcon} className="change-caret" />
      {props.atRest}
      {rendered}
    </div>
  )
}